<template>
        <div v-if="!native" ref="dRef" class="elTableBar" @mouseenter="__computedView" @mousewheel="fn" @mouseleave="__computedView" v-resize="resize">
            <el-scrollbar ref="barRef" :noresize="fixed" wrap-class="ylscroll">
                <div :style=" `width:${!isScrollBar? '100%': !isRep ? this.firefox? '-moz-fit-content': 'fit-content': contentWidth + 'px'}; 
                height:${ fixed ? 'auto' : typeof height === 'number' ? `${height}px` : height }`">
                    <slot />
                </div>
            </el-scrollbar>
        </div>
        <div v-else class="elTableBar-native">
            <slot />
        </div>
    </template>
    
    <script>
    /**
     * element-ui 自定义表格组件
     * 主要特点 将element-ui的表格横向原生滚动条改动为el-scrollbar
     *
     */
    export default {
        name: 'yl-table-bar',
        components: {},
        filters: {},
        props: {
            fixed: {
                // 滚动条适应屏幕滚动，开启此项,则长表格（超出一屏幕）滚动条会默认出现在窗口底部，当表格底部出现在窗口视野，滚动条会复位到表格底部
                type: Boolean,
                default: true
            },
            bottom: {
                // 开启滚动条自适应之后,自适应滚动条距离窗口底部的距离,默认8
                type: Number,
                default: 8
            },
            delay: {
                // 滚轮响应延迟,默认300毫秒，建议不做改动，最小值200,最大值1000
                type: Number,
                default: 300
            },
            static: {
                // 静态表格请开启此项.此props表示是否初始化时计算滚动条，异步获取的表格数据的表格建议保持默认，以节约性能。当表格初始化滚动条错误时，可以考虑打开此项以尝试自我修复
                type: Boolean,
                default: false
            },
            native: {
                // 如果表格列设置 fixed 属性，请开启此项还原滚动条。注意在此项情况下，其他任何设置均不生效
                type: Boolean,
                default: false
            },
            height: {
                // 设置页面高度以保证启用纵向滚动条，当开启fixed模式，该属性会被丢弃
                type: [Number, String],
                default: () => 'auto',
                validator: v => {
                    let regx = /\b\d+\b|\d+px\b|\b\d{1,2}vh\b|auto/
                    return regx.test(v)
                }
            },
            elbarHeight: {
                // 导轨高度
                type: Number,
                default: 8
            },
            elbarmbHeight: {
                // 滑块高度
                type: Number,
                default: 8
            },
            elbarmbBackground: {
                // 滑块颜色
                type: String,
                default: 'rgba(128,128,128,.4)'
            },
        },
        data() {
            return {
                isScrollBar: false, // 控制width 是否为 fit-content (true -> 开启滚动条)
                firefox: false, // 是否为火狐
                isRep: false, // 是否需要兼容
                contentWidth: 0, // 实际宽度
                fn: () => {}, // 辅助函数
                offsetTop: null, // 顶部距离
                Height: null, // 宽
                Width: null, // 高
                offsetLeft: null, // 左侧距离
                isBottom: false, // 是否到底
                elrW: null,
                ellw: null,
                realreg: null,
                scrollLeft: null,
                mbScrollWidth:null,
                fixedStatus:false
            }
        },
        computed: {},
        watch: {},
        created() {
            if (this.fixed && this.native) {
                var delay
                delay = this.delay >= 200 && this.delay <= 1000 ? this.delay : 300
                this.fn = this.__Throttle(this._initWheel, delay);
                delay = null
            }
            this.isAgent();
        },
        mounted() {
            let that = this;
            this.$el.addEventListener("scroll", that.handleScroll, true);
            if (!this.native) {
                this.currentWidth();
                this.$nextTick(()=>{
                    this.__computedView();
                })
            }
        },
        beforeCreate() {},
        beforeMount() {},
        beforeUpdate() {},
        updated() {
            if (!this.native) {
                this.currentWidth();
                this.$nextTick(()=>{
                    this.__computedView();
                })
            }
        },
        beforeDestroy() {},
        activated() {},
        // 自定义指令监听元素宽度
        directives: { 
            resize: { // 指令的名称
                bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
                    let width = '', height = '';
                    function isReize() {
                    const style = document.defaultView.getComputedStyle(el);
                    if (width !== style.width || height !== style.height) {
                        binding.value();  // 关键
                    }
                    width = style.width;
                    height = style.height;
                    }
                    el.__vueSetInterval__ = setInterval(isReize, 300);
                },
                unbind(el) {
                    clearInterval(el.__vueSetInterval__);
                }
            }
        },
        methods: {
            /**
             * 监听滚动
             */
            handleScroll() {
                this.$nextTick(()=>{
                    this.__computedView();
                })
            },
            /**
             * 监听元素宽度变化(左侧菜单展开收起,浏览器缩放拉伸)
             */
            resize(){
                this.__computedView();
            },
            /**
             * 辅助函数
             */
            __computedView() {
                this.currentWidth();
                var el = this.$el
                if (this.fixed) {
                    this._initWheel();//鼠标滚轮事件(纵向滚动条)
                    this.Width = el.getBoundingClientRect().width;
                    this.offsetLeft = this.$mount(this.$refs.barRef).$el.getBoundingClientRect().left;
                    this.offsetTop = el.getBoundingClientRect().top;
                    this.Height = el.getBoundingClientRect().height;
                    var elbar = el.querySelector('.ylscroll').nextElementSibling;
                    var elbarmb = elbar.querySelector('.el-scrollbar__thumb');
                    var realWidth = (this.Width / this.contentWidth) * 100;
                    if (realWidth < 98) {
                        // 当实际宽度不需要显示滚动条则不会显示滚动条
                        elbarmb.style.width = `${realWidth}%`;
                    } else {
                        elbarmb.style.width = '0px';
                    }
                    this._resetStyle();
                    elbarmb = null;
                }
                this.isScrollBar = this.contentWidth * 0.99 > el.getBoundingClientRect().width;
                el = null;
            },
            /**
             * 计算表格内容实际宽度,判断时候需要显示滚动条(由fit-content属性控制)
             */
            currentWidth() {
                this.$nextTick(() => {
                    if(this.$slots.default){
                        var el = (this.$slots.default[0].tag)?(this.$slots.default[0].elm):(this.$slots.default[1].elm);//表格
                        this.contentWidth = el.querySelector('.el-table__header').getBoundingClientRect().width;
                        this.isScrollBar = this.contentWidth * 0.99 >this.$el.getBoundingClientRect().width;
                        // 自定义滑块样式
                        var elbar = this.$el.querySelector('.ylscroll').nextElementSibling;//nextElementSibling: 获取兄弟节点的信息，(用于解决 列表中存在select无法定位滑块)
                        var elbarmb = elbar.querySelector('.el-scrollbar__thumb');
                        if(elbar&&elbarmb){
                            elbar.style.height = this.elbarHeight + 'px';
                            elbarmb.style.height = this.elbarmbHeight + 'px';
                            elbarmb.style.background = this.elbarmbBackground;
                        }
                    }
                })
            },
            /**
             * 检测浏览器是否为IE,Edge
             * 如果是,则进行兼容性处理(修改属性,进行兼容性处理)
             */
            isAgent() {
                var userAgent = window.navigator.userAgent.toLowerCase();
                if (userAgent.indexOf('firefox') > -1) this.firefox = true // 判断是否是火狐，是则需要增加 -moz- 前缀
                if (userAgent.indexOf('trident') > -1 || userAgent.indexOf('windows nt') > -1) {
                    this.isRep = true;
                }
                userAgent = null;
            },
            /**
             * 计算相关参数，开启fixed
             */
            // _initFixed() {
            //     if (this.fixed) {
            //         var el = this.$el;
            //         this.Width = el.getBoundingClientRect().width;
            //         this.offsetLeft = this.$mount(this.$refs.barRef).$el.getBoundingClientRect().left;
            //         this.offsetTop = el.getBoundingClientRect().top;
            //         this.Height = el.getBoundingClientRect().height;
            //         el = null;
            //     }
            //     this._resetStyle();
            // },
            /**
             * 监听鼠标滚轮事件
             */
            _initWheel(ev) {
                var window = this.getClientHeight(); // 可视区域高度
                var scrollTop = document.documentElement.scrollTop || document.body.scrollTop; // 滚动条高度
                this.isBottom = (window + scrollTop) * 0.992 < this.offsetTop + this.Height; // 0.995 粘滞系数
                this._resetStyle();
            },
            /**
             * 修改属性
             */
            _resetStyle() {     
                var el = this.$el;       
                var elbar = el.querySelector('.ylscroll').nextElementSibling;
                if (this.fixed) {
                    if(elbar){
                        if (this.isBottom) {
                            elbar.style.width = `${this.Width}px`;
                            elbar.style.position = `fixed`;
                            elbar.style.left = `${this.offsetLeft}px`;
                            elbar.style.bottom = `${this.bottom}px`;
                            elbar.style['z-index'] = 3;
                        } else {
                            elbar.style.width = ``;
                            elbar.style.position = ``;
                            elbar.style.left = ``;
                            elbar.style.bottom = ``;
                        }                   
                    }
                }
                this.getTableFixedColumn();
                el = null;
            },
            /**
             * 获取窗口可视区域高度
             */
            getClientHeight() {
                var clientHeight = 0;
                if (document.body.clientHeight && document.documentElement.clientHeight) {
                    clientHeight =
                        document.body.clientHeight < document.documentElement.clientHeight ?
                        document.body.clientHeight :
                        document.documentElement.clientHeight;
                } else {
                    clientHeight =
                        document.body.clientHeight > document.documentElement.clientHeight ?
                        document.body.clientHeight :
                        document.documentElement.clientHeight;
                }
                return clientHeight;
            },
            /**
             * 节流函数
             * @param method 事件触发的操作,fn
             * @param delay 间隔多少毫秒需要触发一次事件
             * @returns {Function}
             */
            __Throttle(method, delay = 500) {
                    let timer;
                    let args = arguments;
                    let start;
                    return function loop() {
                        let self = this;
                        let now = Date.now();
                        if (!start) {
                            start = now;
                        }
                        if (timer) {
                            clearTimeout(timer);
                        }
                        if (now - start >= delay) {
                            method.apply(self, args);
                            start = now;
                        } else {
                            timer = setTimeout(function () {
                                loop.apply(self, args);
                            }, 50)
                        }
                    }
                },
            /**
             *  表格固定列处理
             */
            getTableFixedColumn() {
                //contentWidth 表格实际宽度   Width 可视宽度
                if(this.$slots.default){
                    let el = (this.$slots.default[0].tag)?(this.$slots.default[0].elm):(this.$slots.default[1].elm);//表格
                    let elr = el.querySelector('.el-table__fixed-right'); //右定位
                    let ell = el.querySelector('.el-table__fixed'); //左定位
                    let elbar = this.$el.querySelector('.ylscroll').nextElementSibling;//轨道
                    let elbarmb = elbar.querySelector('.el-scrollbar__thumb');//滚动条
                    let barStatus = elbarmb.style.width.split('px')[0];//滚动条存在与否判断
                    this.scrollLeft = this.passTeste(elbarmb);//获取滚动值
                    this.mbScrollWidth = this.Width - (elbarmb.style.width.split('%')[0]/100)*this.Width;
                    // this.realreg = this.scrollLeft / (this.Width / this.contentWidth);
                    this.fixedStatus = ((this.scrollLeft+16)>=this.mbScrollWidth)//判断隐藏阴影
                    // barStatus==1 自适应无滚动条
                    if(barStatus==1||this.fixedStatus){
                        if (elr) {
                            elr.style.boxShadow = 'none';
                        }
                        if(ell){
                            if(this.scrollLeft<=16){
                                ell.style.boxShadow = 'none';
                            }else{
                                ell.style.boxShadow = '0px 0px 12px rgba(0,0,0,.2)';
                            }
                        }
                    }else{
                        if (elr) {
                            elr.style.boxShadow = '0px 0px 12px rgba(0,0,0,.2)';
                        }
                        if (ell) {
                            if(this.scrollLeft<=16){
                                ell.style.boxShadow = 'none';
                            }else{
                                ell.style.boxShadow = '0px 0px 12px rgba(0,0,0,.2)';
                            }
                        }
                    }
                    el = null;
                }
            },
            /**
             *  获取translte 值
             */
            passTeste(obj) {
                if (obj) {
                    let transformValue = window.getComputedStyle(obj);
                    let transform = transformValue.transform || transformValue.webkitTransform || transformValue.mozTransform;
                    if(!transform){ return false }
                    let arr = transform.match(/^matrix\((.+)\)$/);
                    if (arr) {
                        let mat = arr[1].split(',');
                        let matNo = Number(mat[mat.length - 2]);
                        return matNo;
                    }
                }
            }
        }
        }
    </script>
    <style>
    /* 隐藏表格原滚动条 */
    .elTableBar .el-table--scrollable-x .el-table__body-wrapper { overflow-x: hidden;}
    /* 隐藏垂直滚动条 */
    .elTableBar .el-scrollbar__bar.is-vertical{ width: 0;}
    /* 隐藏水平滚动条导轨border */
    .elTableBar .el-scrollbar__bar.is-horizontal{ border: none;}
    /* 修改bar层级 */
    .elTableBar .el-scrollbar__bar{z-index: 3;}
    /* 修改固定列父级 */
    .elTableBar .el-table{ position: static;}
    /* 修改固定列高度 */
    .elTableBar .el-table .el-table__fixed-right,.elTableBar .el-table .el-table__fixed{ height:100%!important}
    /* 横向滚动条默认显示 */
    .el-scrollbar__bar.is-horizontal {opacity: 1;}
    </style>
    